import { AppConstants } from "src/app/common/constants/app-constants";

export type Severity = "Low" | "Medium" | "High";

export const SEVERITY_BY_ID: Record<number, Severity> = {
  1: "Low",
  2: "Medium",
  3: "High",
};

export const SEVERITY_ORDER: Record<Severity, number> = {
  High: 0,
  Medium: 1,
  Low: 2,
};

export const SEVERITY_STYLES: Record<
  Severity,
  { bannerClass: string; badgeClass: string; label: string }
> = {
  High: {
    bannerClass: "announcement-banner-severe",
    badgeClass: "announcement-badge-severe",
    label: "High",
  },
  Medium: {
    bannerClass: "announcement-banner-warning",
    badgeClass: "announcement-badge-warning",
    label: "Medium",
  },
  Low: {
    bannerClass: "announcement-banner-standard",
    badgeClass: "announcement-badge-standard",
    label: "Low",
  },
};

export const DISMISSALS_KEY = "rc_announcement_dismissals_v1";
export const MAX_VISIBLE_BANNERS = 2;
export const CONTENT_PREVIEW_MAX = 140;

/** All user-facing copy for the banner/bell/slideout — kept out of the
 * template so there's one place to change wording, and so any string
 * that's already shared app-wide (e.g. "Close") is reused from AppConstants
 * instead of being redefined here. */
export const ANNOUNCEMENT_BANNER_TEXT = {
  regionLabel: "Announcements",
  slideoutTitle: "Announcements",
  bellLabel: "View all announcements",
  dismissLabelPrefix: "Dismiss: ",
  dismiss: "Dismiss",
  noActiveAnnouncements: "No active announcements.",
  backToList: "All announcements",
  dontShowAgain: "Don't show again",
  close: AppConstants.close,
  moreAnnouncement: "more announcement",
};
